import { render } from "./loaderComponent.vue?vue&type=template&id=f7102760&scoped=true&ts=true"
import script from "./loaderComponent.vue?vue&type=script&lang=ts"
export * from "./loaderComponent.vue?vue&type=script&lang=ts"

import "./loaderComponent.vue?vue&type=style&index=0&id=f7102760&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7102760"]])

export default __exports__